const I18N_BASE_ATTRIBUTE_ENROLL_PROFILE_MAPPINGS = {
  /**
   * Mapping fields in the enroll profile remediation form to their i18n label for localization.
   */
  'enroll-profile.userProfile.login': 'oie.user.profile.login',
  'enroll-profile.userProfile.lastName': 'oie.user.profile.lastname',
  'enroll-profile.userProfile.firstName': 'oie.user.profile.firstname',
  'enroll-profile.userProfile.email': 'oie.user.profile.primary.email',
  'enroll-profile.userProfile.secondEmail': 'oie.user.profile.secondary.email',
  'enroll-profile.userProfile.middleName': 'oie.user.profile.middleName',
  'enroll-profile.userProfile.honorificPrefix': 'oie.user.profile.honorificPrefix',
  'enroll-profile.userProfile.honorificSuffix': 'oie.user.profile.honorificSuffix',
  'enroll-profile.userProfile.title': 'oie.user.profile.title',
  'enroll-profile.userProfile.displayName': 'oie.user.profile.displayName',
  'enroll-profile.userProfile.nickName': 'oie.user.profile.nickName',
  'enroll-profile.userProfile.profileUrl': 'oie.user.profile.profileUrl',
  'enroll-profile.userProfile.mobilePhone': 'oie.user.profile.mobilePhone',
  'enroll-profile.userProfile.primaryPhone': 'oie.user.profile.primaryPhone',
  'enroll-profile.userProfile.streetAddress': 'oie.user.profile.streetAddress',
  'enroll-profile.userProfile.city': 'oie.user.profile.city',
  'enroll-profile.userProfile.state': 'oie.user.profile.state',
  'enroll-profile.userProfile.zipCode': 'oie.user.profile.zipCode',
  'enroll-profile.userProfile.postalCode': 'oie.user.profile.postalCode',
  'enroll-profile.userProfile.countryCode': 'oie.user.profile.countryCode',
  'enroll-profile.userProfile.postalAddress': 'oie.user.profile.postalAddress',
  'enroll-profile.userProfile.preferredLanguage': 'oie.user.profile.preferredLanguage',
  'enroll-profile.userProfile.locale': 'oie.user.profile.locale',
  'enroll-profile.userProfile.timezone': 'oie.user.profile.timezone',
  'enroll-profile.userProfile.userType': 'oie.user.profile.userType',
  'enroll-profile.userProfile.employeeNumber': 'oie.user.profile.employeeNumber',
  'enroll-profile.userProfile.costCenter': 'oie.user.profile.costCenter',
  'enroll-profile.userProfile.organization': 'oie.user.profile.organization',
  'enroll-profile.userProfile.division': 'oie.user.profile.division',
  'enroll-profile.userProfile.department': 'oie.user.profile.department',
  'enroll-profile.userProfile.managerId': 'oie.user.profile.managerId',
  'enroll-profile.userProfile.manager': 'oie.user.profile.manager',
  'enroll-profile.credentials.passcode': 'oie.password.label'
};

export { I18N_BASE_ATTRIBUTE_ENROLL_PROFILE_MAPPINGS };
//# sourceMappingURL=i18nBaseAttributeMappings.js.map
